// awami.in /features: the group chips and the search filter the server-rendered list in the
// browser, with no request. The page reads complete without it.

function setupFilters() {
	const filters = document.querySelector("[data-filters]");
	if (!filters) return;
	const chips = [...filters.querySelectorAll("[data-group]")];
	const search = document.getElementById("feature-search");
	const areas = [...document.querySelectorAll("[data-area]")];
	const empty = document.querySelector("[data-empty]");
	let group = "all";

	function apply() {
		const query = search.value.trim().toLowerCase();
		let shown = 0;
		for (const area of areas) {
			const head = area.querySelector(".area-head").textContent.toLowerCase();
			let itemsShown = 0;
			for (const item of area.querySelectorAll("[data-item]")) {
				const isMatch =
					!query || (head + " " + item.textContent.toLowerCase()).includes(query);
				item.hidden = !isMatch;
				itemsShown += isMatch;
			}
			area.hidden = (group !== "all" && area.dataset.group !== group) || itemsShown === 0;
			shown += !area.hidden;
		}
		empty.hidden = shown > 0;
	}

	filters.addEventListener("click", (event) => {
		const chip = event.target.closest("[data-group]");
		if (!chip) return;
		group = chip.dataset.group;
		chips.forEach((other) => other.setAttribute("aria-pressed", String(other === chip)));
		apply();
	});
	search.addEventListener("input", apply);
}

setupFilters();
